// Promoted from the SmallBiz Design Studio (tools/design-studio/app/base.ts) by pnpm studio:promote (EPIC #7375).
// This copy is now www-sbi code: edit it here. The studio original stays for comparison.
/**
 * Where the studio runs (#7615). Locally the dev server serves it at "/"; online the
 * design-studio-sbs worker serves a build at app.smallbiz.systems/studio/. Every in-app URL goes
 * through at(), so one source works in both places.
 */
// import.meta.env exists under Vite only; plain node (canon.test.mjs) sees the local defaults.
export const BASE: string = import.meta.env?.BASE_URL ?? '/';

/** True in the hosted build: vite.config.ts defines __STUDIO_HOSTED__ (STUDIO_HOSTED=1 at build time). */
declare const __STUDIO_HOSTED__: boolean | undefined;
export const HOSTED: boolean = typeof __STUDIO_HOSTED__ !== 'undefined' && __STUDIO_HOSTED__ === true;

/** A studio path under BASE: at('home.html') is "/home.html" locally and "/studio/home.html" online. */
export const at = (path: string): string => `${BASE}${path.replace(/^\//, '')}`;
